import { omit } from 'lodash';
import { createAction } from 'redux-api-middleware';
import Routes from 'utils/routes.js.erb';
import {
  authHeaders,
  API_FAILURE,
} from './index';

import {
  transformBodyParams,
  tranformSuccessPayload,
} from './transformers';

export const enqueueGroupCohortsCSVReport = () => (dispatch, getState) => {
  const state = getState();
  const params = omit({ ...state.meta.groupCohorts }, ['page', 'per', 'totalPages', 'totalCount']);

  return dispatch(postEnqueueGroupCohortsCSVReport(params));
};

export const ENQUEUE_GROUP_COHORTS_CSV_EXPORT_REQUEST = 'ENQUEUE_GROUP_COHORTS_CSV_EXPORT_REQUEST ';
export const ENQUEUE_GROUP_COHORTS_CSV_EXPORT_RECEIVE = 'ENQUEUE_GROUP_COHORTS_CSV_EXPORT_RECEIVE ';

const postEnqueueGroupCohortsCSVReport = (params) => {
  return async (dispatch, _getState) => {
    const actionResponse = await dispatch(createAction({
      endpoint: Routes.csv_export_api_dashboard_group_cohorts_path(),
      method: 'POST',
      headers: { ...authHeaders(), 'Content-Type': 'application/json' },
      body: transformBodyParams(params),
      types: [
        ENQUEUE_GROUP_COHORTS_CSV_EXPORT_REQUEST,
        tranformSuccessPayload(ENQUEUE_GROUP_COHORTS_CSV_EXPORT_RECEIVE),
        API_FAILURE,
      ],
      fetch: fetch,
    }));

    if (actionResponse && actionResponse.type === ENQUEUE_GROUP_COHORTS_CSV_EXPORT_RECEIVE) {
      clearTimeout(scheduleGroupCohortsCSVReportRefreshId);
      dispatch(fetchGroupCohortsCSVReport());
    }

    return actionResponse;
  };
};

export const GROUP_COHORTS_CSV_REPORT_REQUEST = 'GROUP_COHORTS_CSV_REPORT_REQUEST';
export const GROUP_COHORTS_CSV_REPORT_RECEIVE = 'GROUP_COHORTS_CSV_REPORT_RECEIVE';

const PENDING_GROUP_COHORTS_CSV_REPORT_STATUSES = ['pending', 'in_progress'];

const fetchGroupCohortsCSVReport = () => {
  return async (dispatch, _getState) => {
    const actionResponse = await dispatch(createAction({
      endpoint: Routes.csv_export_api_dashboard_group_cohorts_path(),
      headers: authHeaders(),
      method: 'GET',
      types: [
        GROUP_COHORTS_CSV_REPORT_REQUEST,
        tranformSuccessPayload(GROUP_COHORTS_CSV_REPORT_RECEIVE),
        API_FAILURE,
      ],
      fetch: fetch,
    }));

    if (actionResponse && actionResponse.type === API_FAILURE && actionResponse.payload.status === 429) {
      dispatch(scheduleGroupCohortsCSVReportRefresh());
      return actionResponse.payload.previous;
    }

    if (actionResponse && actionResponse.type === GROUP_COHORTS_CSV_REPORT_RECEIVE) {
      const { status } = actionResponse.payload;

      if (PENDING_GROUP_COHORTS_CSV_REPORT_STATUSES.includes(status)) {
        dispatch(scheduleGroupCohortsCSVReportRefresh());
      }
    }

    return actionResponse;
  };
}

let scheduleGroupCohortsCSVReportRefreshId = null;
const scheduleGroupCohortsCSVReportRefresh = (interval = window.POLLING_INTERVAL) => {
  return (dispatch) => {
    scheduleGroupCohortsCSVReportRefreshId = window.TIMEOUTS.setTimeout(() => {
      dispatch(fetchGroupCohortsCSVReport());
    }, interval);
  };
};

export const loadGroupCohortsCSVReport = (interval = window.POLLING_INTERVAL) => {
  return scheduleGroupCohortsCSVReportRefresh(interval);
}
